<div class="layout-container">
  <fly-header [showAuthInfo]="false"></fly-header>
  <div class="non-header-container">
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
